import { createSelector } from '@reduxjs/toolkit';
import { Store } from 'components/common/types/Store.types';

export const getCampaignPlannerMode = createSelector(
  (state: Store) => state.dealManagement.campaignPlannerMode,
  (campaignPlannerMode) => campaignPlannerMode,
);
